import { getListingWithPrivateData } from './api';

// A person's wallet records and which Persona inquiry verified each document are kept in their
// listing's private data, which the public listing read does not carry. This reads it separately
// and lays it over the listing, on top of any private data the listing already has. If it cannot
// be read, the listing is kept as it came.
export const withOwnPrivateData = async (listing, listingId) => {
  if (!listing) return listing;
  try {
    const response = await getListingWithPrivateData({ listingId, responseFields: ['privateData'] });
    const privateData = response?.data?.data?.attributes?.privateData;
    if (!privateData) return listing;
    const existing = listing.attributes?.privateData || {};
    return {
      ...listing,
      attributes: { ...listing.attributes, privateData: { ...existing, ...privateData } },
    };
  } catch (e) {
    return listing;
  }
};
